import React from 'react';

import styled from 'styled-components';

import Box from '../atoms/Box/Box';
import Text from '../atoms/Text/Text';

import { Align } from '@shared/enums/align';
import { I18nTranslation } from '@shared/interfaces/i18n';
import { breakpoint } from 'theme';
import { withTranslation } from 'i18n';

const mobilePadding = 0.625;
const padding = 1;

type RenewalPriceProps = {
  oldPrice: string;
  price: string;
  t: I18nTranslation;
};

function RenewalPrice({ oldPrice, price, t }: RenewalPriceProps) {
  return (
    <Box
      smPt={mobilePadding}
      smPb={mobilePadding}
      smPl={mobilePadding}
      smPr={mobilePadding}
      pt={padding}
      pb={padding}
      pl={padding}
      pr={padding}
      backgroundColor="wildSand"
    >
      <Box align={Align.Center} mb={0.375}>
        <Text color="cornflowerBlue" smSize={0.75} size={1.125}>
          {t('priceForRenewal')}
        </Text>
      </Box>
      <Prices>
        <OldPrice>{oldPrice}</OldPrice>
        <Price>{price}</Price>
      </Prices>
    </Box>
  );
}

export default withTranslation('common')(RenewalPrice);

const Prices = styled.div`
  display: flex;
  justify-content: center;
`;

const Price = styled.div`
  margin-left: 0.75rem;
  margin-right: 0.75rem;
  font-size: 1.5rem;
  color: ${({ theme }) => theme.colors.cornflowerBlue};
  font-weight: bold;

  ${breakpoint.m`
    font-size: 1.875rem;
  `}
`;

const OldPrice = styled(Price)`
  text-decoration: line-through;
  color: ${({ theme }) => theme.colors.olsoGray};
  font-weight: normal;
`;
